import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { languages } from '../../../configs/env';
import {
  selectMenu,
  selectMeta,
  selectSearchDetailVehicleId
} from '../../../provider/Typo3Provider/selectors';
import { getVehicleDetailSlug } from '../../../provider/Typo3Provider/utils';
import {
  withTypo3,
  WithTypo3Props
} from '../../../provider/Typo3Provider/withTypo3';

/**
 * simple work arround to fix the maximum call stack size exceeded bug
 * @see https://github.com/nfl/react-helmet/issues/373
 * @see https://github.com/nfl/react-helmet/pull/368
 */
class DerivedHelmet extends Helmet {
  public shouldComponentUpdate() {
    return true;
  }
}

interface HelmetContainerProps {}

const HelmetContainer = ({
  typo3,
  location
}: HelmetContainerProps & WithTypo3Props & RouteComponentProps) => {
  const meta = selectMeta(typo3);
  if (meta) {
    const {
      page: {
        title,
        description,
        seoTitle,
        keywords,
        facebookImage,
        twitterImage,
        facebookTitle,
        twitterTitle,
        facebookDescription,
        twitterDescription,
        twitterCreator
      },
    } = meta;

    const ogUrl = `${window.location.origin}${location.pathname}`;
    const ogTitle = seoTitle || facebookTitle || twitterTitle;
    const ogDescription =
      description || facebookDescription || twitterDescription;
    const ogImage: {imageUri: string} | undefined =
      facebookImage ||
      twitterImage ||
      {imageUri: '/fileadmin/user_upload/demo/System/og_image_fallback.jpg'}
    ;

    const vehicleId = selectSearchDetailVehicleId(typo3);
    const vehicleSlug = vehicleId ? getVehicleDetailSlug(typo3, vehicleId) : undefined;

    return (
      <DerivedHelmet defaultTitle="BusStore">
        <title>{seoTitle || `${title} - BusStore`}</title>
        {description && <meta name="description" content={description} />}
        {keywords.length > 0 && <meta name="keywords" content={keywords.join(',')} />}
        {ogUrl && <meta property="og:url" content={ogUrl} />}
        {ogTitle && <meta property="og:title" content={ogTitle} />}
        {ogDescription && (
          <meta property="og:description" content={ogDescription} />
        )}
        {ogImage && <meta property="og:image" content={origin + ogImage.imageUri} />}
        {twitterCreator && (
          <meta name="twitter:creator" content={twitterCreator} />
        )}
        <link rel="canonical" href={ogUrl} />
        {selectMenu(typo3, 'languages').map(({ link, languageUid, available }) => {
          const lang = languages[languageUid || '1'];
          return (
            lang && available && (
              <link
                key={languageUid}
                rel="alternate"
                hrefLang={lang.href_lang}
                href={`${origin}${link}${vehicleSlug || ''}`}
              />
            )
          );
        })}
      </DerivedHelmet>
    );
  }
  return <DerivedHelmet defaultTitle="Busstore" />;
};

export default withRouter(withTypo3(HelmetContainer));
